export default "__VITE_ASSET__CG_MHxLG__"